<template>
    <PageStyleComponent :key="mainComponentKey" :loader="loader" @showLoader="showLoader" @hideLoader="hideLoader">
        <template v-slot:body>
            <div class="mt-6">
                <div class="flex h-16">
                    <DynamicForm  :fields="formFields" :flex_basis="flex_basis" :flex_basis_percentage="flex_basis_percentage" @handleReset="handleReset" /> 
                    <button @click="fetchEmployees" class="rounded bg-green-400 text-sm h-8 w-24 mt-2 text-white px-1.5 py-1.5"><i class="fa fa-check-circle text-xs mr-1.5" aria-hidden="true"></i>Load</button>
                </div>
                <div>
                    <p class="text-gray-400"></p>
                </div>
                <div class="min-h-[480px]">
                    <DynamicTable :key="tableKey" :columns="readingColumns" :rows="attendanceRows" :showActions="showActions" :idField="idField" :actions="actions" />
                </div>
                <div class="flex-1 basis-full px-2 mt-6">
                    <button @click="createEmployeeAttendance" class="rounded bg-green-400 text-sm mr-2  text-white px-2 py-1.5"><i class="fa fa-check-circle text-xs mr-1.5" aria-hidden="true"></i>Save</button>
                    <button @click="handleReset" class="rounded bg-green-400 text-sm mr-2  text-white px-2 py-1.5"><i class="fa fa-refresh text-xs mr-1.5" aria-hidden="true"></i>Reset</button>
                </div>
            </div>
        </template>
    </PageStyleComponent>
</template>

<script>
import { defineComponent, ref, onBeforeMount, onMounted, computed, watch } from 'vue';
import DynamicForm from '@/components/NewDynamicForm.vue';
import DynamicTable from '../DynamicTable.vue';
import PageStyleComponent from '@/components/PageStyleComponent.vue';
import { useStore } from "vuex";
import { useToast } from "vue-toastification";

export default defineComponent({
    name: 'Employee_Attendances',
    components:{
        PageStyleComponent, DynamicForm, DynamicTable
    },
    setup(){
        const store = useStore();
        const toast = useToast();
        const loader = ref('none');
        const mainComponentKey = ref(0);
        const tableKey = ref(0);
        const propComponentKey = ref(0);
        const setupComponentKey = ref(0);
        const current_date = ref('');
        const units_cost = ref(0);
        const meter_rent = ref(0);
        const errors = ref([]);
        const companyID = computed(()=> store.state.userData.company_id);
        const flex_basis = ref('');
        const flex_basis_percentage = ref('');
        const projectArray = computed(() => store.state.Projects.projectArr);
        const projectID = ref('');
        const branchArray = computed(() => store.state.Branches.branchArr);
        const branchID = ref('');
        const attendanceRows = computed(() => store.state.Attendances.emplAttendances);
        const attendanceStatus = computed(() => store.getters['Attendances/getAttendanceStatus']);
        const idField = ref('');
        const showActions = ref(false);
        const readingColumns = ref([
            {type: "checkbox"},
            {label: "Employee Name", key:"employee_name"},
            {label: "Staff No", key:"staff_number"},
            {label: "Status", key: "status", textColor: "statusColor", type: "select-dropdown", options: attendanceStatus},
            {label: "Check In", key: "arrival_time", type: "text"},
            {label: "Time In", key: "check_in", type: "time", editable: true},
            {label: "Late Mins", key: "late_minutes", type: "number", editable: true},
            {label: "Time Out", key: "check_out", type: "time", editable: true},
            {label: "Breaks(Mins)", key: "break_minutes", type: "number"},
            {label: "Total Hrs", key: "total_hours", type: "number", editable: true},
            {label: "Overtime", key: "overtime_hours", type: "number", editable: true},
        ])

        const actions = ref([
            {}
        ])

        const fetchProjects = async() =>{
            await store.dispatch('Projects/fetchProjects', {company:companyID.value})
        };
        const handleSelectedProject = async(option) =>{
            await store.dispatch('Projects/handleSelectedProject', option)
            projectID.value = store.state.Projects.projectID;
        };
        const clearSelectedProject = async() =>{
            await store.dispatch('Projects/updateState', {projectID: ''});
            projectID.value = "";
        };
        const fetchBranches = async() =>{
            await store.dispatch('Branches/fetchBranches', {company:companyID.value})       
        };
        
        const handleSelectedBranch = async(option) =>{
            await store.dispatch('Branches/handleSelectedBranch', option)
            branchID.value = store.state.Branches.branchID;
        };
        const clearSelectedBranch = async() =>{
            await store.dispatch('Branches/updateState', {branchID: ''});
            branchID.value = "";
        }
        const formFields = ref([]);
        const updateFormFields = () => {
            formFields.value = [
                {  
                    type:'search-dropdown', label:"Project", value: projectID.value, componentKey: propComponentKey,
                    selectOptions: projectArray, optionSelected: handleSelectedProject, required: false,
                    searchPlaceholder: 'Select Project...', dropdownWidth: '330px', updateValue: "",
                    clearSearch: clearSelectedProject() 
                },
                {  
                    type:'search-dropdown', label:"Branch", value: branchID.value, componentKey: setupComponentKey,
                    selectOptions: branchArray, optionSelected: handleSelectedBranch, required: false,
                    searchPlaceholder: 'Select Branch...', dropdownWidth: '330px', updateValue: "",
                    clearSearch: clearSelectedBranch()
                },
                { type: 'date', name: 'reading_date',label: "Curr Date", value: "", required: true },    
                
            ];
        };
        const handleReset = async() =>{
            for(let i=0; i < formFields.value.length; i++){
                formFields.value[i].value = '';
            }
            projectID.value = '';
            branchID.value = '';
            propComponentKey.value += 1;
            setupComponentKey.value += 1;
            await store.dispatch('Attendances/updateState',{emplAttendances: []})
        }
        const fetchEmployees = async() =>{
            if(formFields.value[2].value == ""){
                toast.error("Please Select Date!")
            }else{
                if(projectID.value && branchID.value){
                    await store.dispatch('Attendances/fetchAttendanceEmployees', {company:companyID.value, date:formFields.value[2].value, project: projectID.value, branch:branchID.value})
                }else if(projectID.value && !branchID.value) {
                await store.dispatch('Attendances/fetchAttendanceEmployees', {company:companyID.value, date:formFields.value[2].value, project: projectID.value}) 
                } else if(!projectID.value && branchID.value){
                    await store.dispatch('Attendances/fetchAttendanceEmployees', {company:companyID.value, date:formFields.value[2].value, branch:branchID.value})
                }else{
                    await store.dispatch('Attendances/fetchAttendanceEmployees', {company:companyID.value, date:formFields.value[2].value})
                }
            }
        };
         
        const showLoader = () =>{
            loader.value = "block";
        }
        const hideLoader = () =>{
            loader.value = "none";
        } 
        const createEmployeeAttendance = async() =>{
            showLoader();
            let formData = {
                company: companyID.value,
                branch: branchID.value,
                project: projectID.value,
                date: formFields.value[2].value,
                employees: attendanceRows.value,
            }

            errors.value = [];

            for(let i=2; i < formFields.value.length; i++){
                if(formFields.value[i].value =='' && formFields.value[i].required == true){
                    errors.value.push(formFields.value[i].label);
                }
            }
  
            if(errors.value.length){
                toast.error('Fill In Required Fields');
                hideLoader();                 
            }else{            
                try {
                    const response = await store.dispatch('Attendances/createAttendance', formData);
                    if (response && response.status === 201) {
                        hideLoader();
                        toast.success('Attendances created successfully!');
                        handleReset();
                        mainComponentKey.value += 1;
                        propComponentKey.value += 1;
                        setupComponentKey.value += 1;
                    } else {
                        toast.error('An error occurred while creating the attendances.');
                        hideLoader();
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to create attendances: ' + error.message);
                } finally {
                    hideLoader();
                }              
            }
        }
        
        onBeforeMount(()=>{ 
            fetchProjects();
            fetchBranches();
            updateFormFields();
            propComponentKey.value += 1;
            setupComponentKey.value += 1;
            flex_basis.value = '1/4';
            flex_basis_percentage.value = '25';
        })
        onMounted(()=>{
            attendanceRows.value = [];
        })

        return{
            tableKey, formFields, flex_basis, flex_basis_percentage, createEmployeeAttendance, mainComponentKey, actions,
            handleReset, loader, showLoader, hideLoader, readingColumns, attendanceRows, idField, fetchEmployees,
            showActions
        }
    }
})
</script>